import React from 'react';
import { motion } from 'framer-motion';
import { Star, Check } from 'lucide-react';
export function PricingSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-189">
      <div className="text-center mb-12" data-id="element-190">
        <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-191">
          ELEGÍ TU KIT
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-192">
        {/* Basic Kit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy-800/50 border border-navy-600 rounded-3xl p-8 flex flex-col relative" data-id="element-193">
          <div className="mb-6" data-id="element-194">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-195">
              🌙 KIT SOS NOCTURNO
            </h3>
            <p className="text-blue-200 text-sm font-medium mb-4" data-id="element-196">
              6 Tomos + 6 Bonos
            </p>
            <p className="text-blue-100/80 text-sm min-h-[40px]" data-id="element-197">
              Para padres que necesitan un sistema completo desde cero
            </p>
          </div>

          <div className="mb-8" data-id="element-198">
            <p className="text-gray-400 line-through text-lg mb-1" data-id="element-199">$51.000</p>
            <div className="flex items-baseline gap-2" data-id="element-200">
              <span className="text-4xl font-bold text-white" data-id="element-201">$19.990</span>
              <span className="text-xl text-blue-200" data-id="element-202">ARS</span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-203">
            <a href="https://www.mundorecursos.store/cart/45107830423631:1" className="block w-full py-4 px-6 bg-navy-700 hover:bg-navy-600 text-white font-bold text-center rounded-xl transition-colors border border-navy-500" data-id="element-204">
              → QUIERO MI KIT SOS NOCTURNO
            </a>
          </div>
        </motion.div>

        {/* Premium Kit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-b from-navy-800 to-navy-900 border-2 border-gold-500 rounded-3xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(212,168,83,0.15)] transform md:-translate-y-4" data-id="element-205">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold-500 text-navy-900 font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 whitespace-nowrap shadow-lg" data-id="element-206">
            <Star className="w-4 h-4 fill-navy-900" data-id="element-207" /> MÁS ELEGIDO
          </div>

          <div className="mb-6 mt-2" data-id="element-208">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-209">
              🏆 KIT COMPLETO + AUTONOMÍA NOCTURNA{' '}
              <Star className="w-5 h-5 text-gold-400 fill-gold-400" data-id="element-210" />
            </h3>
            <p className="text-gold-400 text-sm font-medium mb-4" data-id="element-211">
              6 Tomos + 6 Bonos + Guía Avanzada de 12 Horas
            </p>
            <p className="text-blue-100/80 text-sm min-h-[40px]" data-id="element-212">
              Para padres que ya avanzaron y quieren llegar a noches lineales de
              10 a 12 horas
            </p>
          </div>

          <div className="mb-8" data-id="element-213">
            <p className="text-gray-400 line-through text-lg mb-1" data-id="element-214">$69.000</p>
            <div className="flex items-baseline gap-2" data-id="element-215">
              <span className="text-5xl font-bold text-gold-400" data-id="element-216">$27.990</span>
              <span className="text-xl text-gold-400/80" data-id="element-217">ARS</span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-218">
            <a href="https://www.mundorecursos.store/cart/45107829932111:1" className="block w-full py-4 px-6 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-900 font-bold text-center rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-219">
              → QUIERO EL KIT COMPLETO + AUTONOMÍA NOCTURNA
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}